import { render, staticRenderFns } from "./YesNoSelect.vue?vue&type=template&id=dd9a870c&"
import script from "./YesNoSelect.vue?vue&type=script&lang=ts&"
export * from "./YesNoSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports